module.exports = __webpack_public_path__ + "img/nissan.c92bea20.jpg";